<template>
    <div class="box-second">
        <p class="title">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>设备管理</el-breadcrumb-item>
                <el-breadcrumb-item>龙门吊设备</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="build-bar">
                <span>设备名称：</span>
                <el-input placeholder="请输入设备名称" v-model="tableDataName"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>
                <el-button type="primary" @click="addRow()">添加设备</el-button>
            </div>
            <div class="build-table">
                <el-table :data="tableDataEnd" ref="tableDataBegin" style="width: 100%;">
                <template slot="empty">
                    <p>{{dataText}}</p>
                </template>
                <el-table-column label="序号" width="80">
                    <template slot-scope="scope">
                    <span>{{ scope.row.index }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备名称">
                    <template slot-scope="scope">
                    <a>{{ scope.row.name}}</a>
                    </template>
                </el-table-column>
                <el-table-column label="厂家">
                    <template slot-scope="scope">
                      <span v-if="scope.row.machType=='1'">海智</span>
                      <span v-else-if="scope.row.machType=='2'">瞳声</span>
                      <span v-else-if="scope.row.machType=='3'">DTU设备</span>
                      <span v-else></span>
                    </template>
                </el-table-column>
                <el-table-column label="设备编号">
                    <template slot-scope="scope">
                    <span>{{ scope.row.deviceId }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备状态">
                    <template slot-scope="scope">
                      <span v-if="scope.row.connectedStatus=='在线'" style="color:#67C23A;">{{ scope.row.connectedStatus }}</span>
                      <span v-else>{{ scope.row.connectedStatus||'离线' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="班组">
                    <template slot-scope="scope">
                    <span>{{ scope.row.teamsName}}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="摄像头">
                    <template slot-scope="scope">
                    <span v-if="scope.row.camera">{{ scope.row.camera.name }}</span>
                    </template>
                </el-table-column> -->
                <el-table-column label="时间">
                    <template slot-scope="scope">
                    <span>{{ scope.row.updateDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width='300'>
                    <template slot-scope="scope">
                      <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                      <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                      <el-button size="mini" type="primary" @click="setWeight(scope.row)">重量设置</el-button>
                    </template>
                </el-table-column>
                <!-- 新增窗口 -->
                <el-dialog
                    :title="dialogTitle"
                    :visible.sync="addFormVisible"
                    center
                    :append-to-body="true"
                    :lock-scroll="false"
                    class="add-form"
                    width="30%"
                >
                    <el-form
                    :model="addForm"
                    ref="addForm"
                    label-width="100px"
                    :label-position="labelPosition"
                    :rules="rules"
                    >
                    <el-form-item label="设备名称：" prop="name">
                        <el-input
                        v-model="addForm.name"
                        placeholder="请输入设备名称"
                        autocomplete="off"
                        @input="updateTotal($event)"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="厂家名称：" prop="machType">
                        <el-select v-model="addForm.machType" @change="$forceUpdate()">
                        <el-option
                            v-for="item in crane"
                            :key="item.index"
                            :label="item.machType"
                            :value="item.value"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="设备编号：" prop="deviceId">
                        <el-input
                        v-model="addForm.deviceId"
                        placeholder="请输入设备编号"
                        autocomplete="off"
                        @input="updateTotal($event)"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="人脸识别编号:">
                        <el-select v-model="addForm.attendanceSn" @change="$forceUpdate()">
                        <el-option
                            v-for="item in groups"
                            :key="item.id"
                            :label="item.imei"
                            :value="item.imei"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="班组:">
                        <el-select v-model="addForm.teamsId" @change="$forceUpdate()">
                        <el-option
                            v-for="item in teams"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="摄像头:">
                        <el-select v-model="addForm.cameraId" @change="$forceUpdate()">
                        <el-option
                            v-for="item in cameras"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                        </el-select>
                    </el-form-item> -->
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                      <el-button @click="addFormVisible = false">取 消</el-button>
                      <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                    </div>
                  </el-dialog>
                </el-table>
                
                <!-- <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[3, 5, 10]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
                ></el-pagination>-->
                
            </div>
        </div>
        <!-- 维护标准窗口 -->
        <el-dialog
            title="参数配置"
            :visible.sync="editFormVisible"
            center
            :append-to-body="true"
            :lock-scroll="false"
            custom-class='tower-dig'
            class="add-form"
            width="30%"
        >
          <div class="config-con">
            <p class="config-con-item" v-for="(item,index) in configList" :key="index">
              <span style="display: inline-block;width: 6vw;">{{item.name}}</span>
              <span style="display: inline-block;width: 7vw;">单位：（{{item.unit}}）</span>
              <span style="display: inline-block;width: 14vw;">设置值：<el-input v-model="item.val" placeholder="请输入" style="width:5vw;"></el-input> {{item.unit}}</span>
              <!-- <span>默认使用系统设置</span>
              <el-switch
                v-model="item.status"
                inactive-text="关闭">
              </el-switch> -->
            </p>
          </div>
          <div slot="footer" class="dialog-footer" style="">
              <el-button @click="editFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="sumbitEditRow">确 定</el-button>
          </div>
        </el-dialog>
    </div>
</template>
<script>
import util from '../../../untils/util'
import base from '../../../untils/base'
import myHttp from '../../../untils/port'
export default {
  data() {
    return {
      crane: [
        { machType: '海智', value: '1' },
        { machType: '瞳声', value: '2' },
        { machType: 'DTU设备', value: '3' },
      ], // 下拉菜单组
      machType: '海智', // 下拉菜单默认数据
      dialogTitle: '编辑窗口', //弹出框标题
      labelPosition: 'right', // 添加设备弹出框position属性
      addForm: {
        // id: '',
        // name: '',
        // machType: '',
        // deviceId: '',
        // statusStr: '',
        // reason: '',
        // updateDate: ''
      }, // 添加设备表单数组
      addFormVisible: false, // 弹出框是否显示
      tableDataName: '', // 搜索数据名
      tableDataEnd: [], // 监控表单数据
      // filterTableDataEnd: [],
      currentPage: 1, // 表单列表默认页
      pageSize: 10, // 表单列表默认显示数
      totalItems: 0, // 表单列表全部长度
      flag: false, // 搜索数据flag值
      groupId: util.session.get('groupId'),
      dataText: '数据加载中...',
      groups: [],
      teams: [],
      rules: {
        name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        machType: [
          { required: true, message: '请选择厂家名称', trigger: 'blur' }
        ],
        deviceId: [
          { required: true, message: '请输入设备编号', trigger: 'blur' }
        ]
      },
      //参数配置
      editFormVisible:false,
      configList:[
        {name:'重量',unit:'T',val:'',status:true},
        // {name:'塔吊设备回转',unit:'度',val:'',status:true},
        // {name:'设备幅度',unit:'度',val:'',status:true},
        // {name:'吊钩高度',unit:'米',val:'',status:true},
        // {name:'额定吊重',unit:'吨',val:'',status:true},
        // {name:'塔吊力矩',unit:'百分比',val:'',status:true},
        // {name:'风速',unit:'米每秒',val:'',status:true},
        // {name:'前倾角',unit:'度',val:'',status:true},
      ],
      configData:{
        id:'',
        projectId:'',
        projectName:'',
        angleSwitch:'',  //回转开关   1开  2关
        angle:'',        //回转
        radiusSwitch:'',    // 幅度  开关  1开  2关
        radius:'',          // 幅度
        hightSwitch:'',   //高度开关
        hight:'',         //高度
        loadweightrSwitch:'',  //吊重开关
        loadweightr:'',  //吊重
        lijupercentSwitch:'',  // 力矩百分比  开关
        lijupercent:'',     //力矩百分比
        windspeedSwitch:'', //风速开关
        windspeed:'',    //风速
        fallSwitch:'', //倾角 开关
        fall:'',//倾角
        // ratedWeightSwitch:'',// 额定吊重 开关
        // ratedWeight:'',//额定吊重
        createBy:'',
      },
      cameras:[],//摄像头列表
    }
  },
  mounted() {
    this.getData()
    this.getList()
  },
  methods: {
    // 搜索数据 111
    doFilter() {
      this.getData()
      // var that = this
      // var option = {
      //   name: this.tableDataName,
      //   pageNum: this.currentPage,
      //   pageSize: this.pageSize,
      //   projectId: util.session.get('groupId')
      // }
      // myHttp.getListByTowerProjectId(option).then(function(resp) {
      //   if (resp.data.code == '200') {
      //     var list = resp.data.data.towerList || [],
      //       arr = []
      //     for (var i = 0; i < list.length; i++) {
      //       if (list[i].name.split(that.tableDataName).length > 1) {
      //         arr.push(list[i])
      //         list[i].index = arr.length
      //       }
      //     }
      //     that.tableDataEnd = arr
      //     if (that.tableDataEnd != '') {
      //       that.$message.success('搜索如下')
      //     } else {
      //       that.$message.error('数据不存在')
      //     }
      //   } else {
      //     that.$message.error(resp.data.msg)
      //   }
      // })
    },
    // handleSizeChange(val) {
    //   this.pageSize = val
    //   this.handleCurrentChange(this.currentPage)
    // },
    // handleCurrentChange(val) {
    //   console.log(`当前页: ${val}`)
    //   this.currentPage = val
    //   this.getData()
    // },
    // // 监控当前页码
    // currentChangePage() {
    //   this.getData()
    // },

    // 获取数据
    getData() {
      var option = {
        name: this.tableDataName,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        projectId: util.session.get('groupId')
      }
      var that = this
      myHttp.selectEquipGantryList(option).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.equipGantrys || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
            }
            that.tableDataEnd = list
            that.totalItems = list.length
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },

    // 编辑数据
    handleEdit(index, row) {
      this.getTeams()
      this.dialogTitle = '编辑设备信息'
      this.addFormVisible = true
      this.addForm.id = row.id
      this.addForm.projectId = row.projectId
      this.addForm.machType = row.machType
      this.addForm.name = row.name
      this.addForm.status = row.status
      this.addForm.statusStr = row.statusStr
      this.addForm.attendanceSn = row.attendanceSn
      this.addForm.deviceId = row.deviceId
      this.addForm.teamsId = row.teamsId
      this.getCameraList()
    },

    // 删除数据
    handleDelete(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp
          .deleteEquipGantry({
            id: row.id
          })
          .then(function(resp) {
            if (resp.data.code == '200') {
              that.$message.success('删除成功')
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      })
    },
    // 获取班组
    getTeams() {
      // getTeamsListtz
        var that = this
        myHttp.getTeamsListtz({
          projectId: util.session.get('groupId')
        }).then(
          function(resp) {
            if (resp.data.code == '200') {
              that.teams = resp.data.data.teamsList || []
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    /**
     * 新增设备
     */
    addRow() {
      this.getTeams()
      this.dialogTitle = '新增设备'
      this.addFormVisible = true
      this.addForm = {
        id: '',
        name: '',
        machType: '',
        deviceId: '',
        projectId: util.session.get('groupId'),
        attendanceSn: '',
        teamsId: ''
      }
      this.getCameraList()
    },

    // 将新增的数据添加到表格中
    sumbitAddRow(formName) {
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (that.addForm.id == '') {
            if (that.addForm.password == '') {
              that.$message.error('创建时请输入密码！')
              return
            }
            //添加
            myHttp.createEquipGantry(that.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.addFormVisible = false
                  that.currentPage = 1
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          } else {
            //修改
            delete that.addForm.updateDate
            if (that.addForm.password == '') {
              delete that.addForm.password
            }
            myHttp.towerUpdateInfo(that.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改成功')
                  that.addFormVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          }
        }
      })
    },
    cancel() {
      this.addFormVisible = false
      this.editFormVisible = false
    },
    // 关闭弹出框弹窗
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    // 人脸识别编号列表
    getList() {
        var that = this
        myHttp.getRecogByProjectId({
          projectId: util.session.get('groupId')
        }).then(
          function(resp) {
            if (resp.data.code == '200') {
              //  console.log(resp)
              var list = resp.data.data.pageInfo || []
              that.groups = list
            } else {
              that.$message.error(resp.data.msg)
              that.dataText = '暂无数据'
            }
          },
          function() {}
        )
    },
    updateTotal(e) {
      this.$forceUpdate()
    },

    //数据转列表
    setConfigList(data){
      for(var i=0;i<this.configList.length;i++){
        if(i==0){
          this.configList[i].val = data.angle
          this.configList[i].status = this.configData.angleSwitch=='2'?false:true
          // this.configData.pm2 = this.configList[i].val
          // this.configData.pm2Switch = this.configList[i].status?'1':'2'
        }else if(i==1){
          this.configList[i].val = data.radius
          this.configList[i].status = this.configData.radiusSwitch=='2'?false:true
          // this.configData.pm10 = this.configList[i].val
          // this.configData.pm10Switch = this.configList[i].status?'1':'2'
        }else if(i==2){
          this.configList[i].val = data.hight
          this.configList[i].status = this.configData.hightSwitch=='2'?false:true
          // this.configData.noise = this.configList[i].val
          // this.configData.noiseSwitch = this.configList[i].status?'1':'2'
        }else if(i==3){
          this.configList[i].val = data.loadweightr
          this.configList[i].status = this.configData.loadweightrSwitch=='2'?false:true
          // this.configData.temperature = this.configList[i].val
          // this.configData.temperatureSwitch = this.configList[i].status?'1':'2'
        }else if(i==4){
          this.configList[i].val = data.lijupercent
          this.configList[i].status = this.configData.lijupercentSwitch=='2'?false:true
          // this.configData.humidity = this.configList[i].val
          // this.configData.humiditySwitch = this.configList[i].status?'1':'2'
        }else if(i==5){
          this.configList[i].val = data.windspeed
          this.configList[i].status = this.configData.windspeedSwitch=='2'?false:true
          // this.configData.windSpeed = this.configList[i].val
          // this.configData.windSpeedSwitch = this.configList[i].status?'1':'2'
        }else if(i==6){
          this.configList[i].val = data.fall
          this.configList[i].status = this.configData.fallSwitch=='2'?false:true
        }
      }
    },

    //配置
    setWeight(){
      this.dialogTitle = '参数配置'
      this.editFormVisible = true
      this.configData.projectId = util.session.get('groupId')
      this.configData.projectName = this.projectName
      var that = this
      myHttp.selectTowerCopy({
        projectId:util.session.get('groupId')
      }).then(function(resp){
        if(resp.data.code=='200'){
          var data = resp.data.data.TowerCopy
          if(data){
            that.hasConf = true
            that.configData = data
            that.setConfigList(data)
          }else{
            that.hasConf = false
          }
        }else{
          that.$message.error(resp.data.msg)
        }
      })
    },

    // 维护环境标准configData
    sumbitEditRow(formName) {
      var that = this
      for(var i=0;i<this.configList.length;i++){
        if(i==0){
          this.configData.angle = this.configList[i].val
          this.configData.angleSwitch = this.configList[i].status?'1':'2'
        }else if(i==1){
          this.configData.radius = this.configList[i].val
          this.configData.radiusSwitch = this.configList[i].status?'1':'2'
        }else if(i==2){
          this.configData.hight = this.configList[i].val
          this.configData.hightSwitch = this.configList[i].status?'1':'2'
        }else if(i==3){
          this.configData.loadweightr = this.configList[i].val
          this.configData.loadweightrSwitch = this.configList[i].status?'1':'2'
        }else if(i==4){
          this.configData.lijupercent = this.configList[i].val
          this.configData.lijupercentSwitch = this.configList[i].status?'1':'2'
        }else if(i==5){
          this.configData.windspeed = this.configList[i].val
          this.configData.windspeedSwitch = this.configList[i].status?'1':'2'
        }else if(i==6){
          this.configData.fall = this.configList[i].val
          this.configData.fallSwitch = this.configList[i].status?'1':'2'
        }
      }
      delete this.configData.createDate
      delete this.configData.updateDate
      if(this.hasConf){
        this.configData.updateBy = util.session.get('user').id
        myHttp.updateTowerCopy(this.configData).then(function(resp){
          if(resp.data.code=='200'){
            that.$message.success('配置成功')
            that.editFormVisible = false
          }else{
            that.$message.error(resp.data.msg)
          }
        })
      }else{
        this.configData.createBy = util.session.get('user').id
        myHttp.addTowerCopy(this.configData).then(function(resp){
          if(resp.data.code=='200'){
            that.$message.success('配置成功')
            that.editFormVisible = false
          }else{
            that.$message.error(resp.data.msg)
          }
        })
      }
    },

    //获取摄像头列表
    getCameraList(){
      var that = this
      myHttp.selectCameraByUseType({
        projectId:util.session.get('groupId'),
        useType:'2'
      }).then(function(resp){
        // console.log(resp)
        if(resp.data.code=='200'){
          var list = resp.data.data.Camera||[]
          that.cameras = list
        }
      })
    },
  }
}
</script>
<style scoped>
    .box-second{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .title{
        width: 100%;
        height: 3vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding-left: 1vw;
    }
    .main{
        width: 100%;
        height: calc( 100% - 3vh );
        position: relative;
        display: flex;
        padding: 0 1vw 0.5vw;
        flex-wrap: wrap;
    }
    .build-bar {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 8vh;
        /* border-top: 3px solid rgb(224, 224, 224); */
        border-bottom: 3px solid #17b2fe;
        background: #fff;
    }

    .build-bar span {
        margin-left: 30px;
        white-space: nowrap;
        display: inline-block;
    }

    .build-bar > .el-input {
        width: 200px;
        font-size: 12px;
    }

    .build-bar > .el-button {
        margin-left: 30px;
        background-color: #17b2fe;
        border-color: #17b2fe;
    }

    .build-bar > .el-button:last-child {
        margin-right: 20px;
    }

    .build-bar .btnLef {
        position: absolute;
        right: 6%;
        display: block;
        width: 95px;
        height: 40px;
        line-height: 40px;
        color: #fff;
        border-radius: 4px;
        background: #ffaf15;
        border: 1px solid #ffb800;
    }

    .el-select .el-input {
        width: 130px;
    }

    .input-with-select .el-input-group__prepend {
        background-color: #fff;
    }

    .build-table {
        position: relative;
        width: 100%;
        background: #fff;
        height: calc( 100% - 8vh );
        /* margin: 0 auto; */
    }

    .el-table .el-table-column:not(:first-child) {
        border: 1px solid slategrey;
    }

    .el-table >>> .cell {
        overflow: hidden;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
    }

    .add-form {
        margin-top: 10vh;
    }

    .add-form .el-form-item {
        margin-top: 30px;
    }

    .el-pagination {
        padding: 20px 0;
    }
    
</style>
<style>
    .tower-dig .el-dialog__title{
      color: #0085FF;
    }
    .tower-dig .el-dialog__body,.tower-dig .el-dialog__footer{
      border-top: 1px solid #ddd;
    }
    .tower-dig span{
      font-weight: bold;
    }
    .tower-dig .el-dialog__header{
      text-align: left;
    }
    .config-con{
      display:flex;
      flex-wrap:wrap;
      width:100%;
      height:auto;
    }
    .config-con-item{
      width:100%;
      padding:1vh 0;
      display:flex;
      justify-content: space-around;
      align-items: center;
      align-content: center;
    }
@import '../../../assets/css/common.css';
</style>